import { Menu } from 'antd';
import type { MenuProps } from 'antd';
import styled from 'styled-components';
import type { AppSidebarSize } from './AppSidePanel';

/** Layout only. Item colors come from `var(--color-*)` so each app’s theme applies. */

const hideMenuActiveBar = `
  .ant-menu-item::after,
  .ant-menu-item-selected::after {
    display: none !important;
    border: none !important;
    opacity: 0 !important;
  }
`;

const StyledMenuWide = styled(Menu)`
  position: relative;
  margin-top: 0;
  font-weight: 600;
  border-inline-end: none !important;
  background: transparent !important;
  ${hideMenuActiveBar}
  .ant-menu-item-icon {
    color: var(--color-sidebar-icon, #879494) !important;
    width: 20px !important;
    height: 20px !important;
  }
  .ant-menu-item-divider {
    border-color: var(--color-primary, #41aaaf);
    opacity: 25%;
    margin: 20px 0;
  }
  .ant-menu-item {
    margin: 10px 0 !important;
    display: flex;
    align-items: center;
    height: 34px !important;
    line-height: 34px !important;
    width: 100% !important;
    color: var(--color-text-dark, #042a2a) !important;
    border-radius: 10px !important;
  }
  .ant-menu-item-selected {
    background-color: var(--color-surface-raised, #ffffff) !important;
    color: var(--color-text-dark, #042a2a) !important;
  }
  .ant-menu-item:hover,
  .ant-menu-item-active {
    background-color: var(--color-surface-raised, #ffffff) !important;
    color: var(--color-text-dark, #042a2a) !important;
  }
`;

const StyledMenuNarrow = styled(Menu)`
  position: relative;
  margin-top: 8px;
  font-weight: 600;
  border-inline-end: none !important;
  background: transparent !important;
  ${hideMenuActiveBar}
  .ant-menu-item-icon {
    color: var(--color-sidebar-icon, #879494) !important;
  }
  .ant-menu-item-divider {
    border-color: var(--color-primary, #41aaaf);
    opacity: 25%;
    width: 32px;
    margin-block: 16px;
    margin-inline: auto;
  }
  .ant-menu-item {
    margin: 10px 0 !important;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: auto !important;
    min-height: 52px !important;
    width: auto !important;
    min-width: 56px !important;
    max-width: calc(100% - 12px) !important;
    margin-inline: auto !important;
    line-height: 1 !important;
    padding-inline: 4px !important;
    color: var(--color-text-dark, #042a2a) !important;
    border-radius: 10px !important;
  }
  .ant-menu-item-selected {
    background-color: var(--color-surface-raised, #ffffff) !important;
  }
  .ant-menu-item:hover,
  .ant-menu-item-active {
    background-color: var(--color-surface-raised, #ffffff) !important;
  }
  .ant-menu-title-content {
    font-size: 10px;
    margin-inline-start: 0 !important;
    white-space: normal;
    line-height: 12px;
    text-align: center;
    margin-top: 3px;
    max-width: 100%;
    overflow: visible;
    word-break: break-word;
  }
`;

export type AppSideMenuProps = {
  size: AppSidebarSize;
  items: MenuProps['items'];
  selectedKeys: string[];
  onClick: MenuProps['onClick'];
};

export const AppSideMenu = ({
  size,
  items,
  selectedKeys,
  onClick,
}: AppSideMenuProps) => {
  const MenuComponent = size === 'wide' ? StyledMenuWide : StyledMenuNarrow;
  return (
    <MenuComponent
      onClick={onClick}
      selectedKeys={selectedKeys}
      mode="vertical"
      items={items}
    />
  );
};
